import { render, staticRenderFns } from "./EditarAlertaModal.vue?vue&type=template&id=31208c26&"
import script from "./EditarAlertaModal.vue?vue&type=script&lang=ts&"
export * from "./EditarAlertaModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports